import { FeatureFlag } from '../FeatureFlag';

export const enableLabFirmBorrowStatus = new FeatureFlag({
    key: 'enable-lab-firm-borrow-status',
    defaultValue: false,
});
